import { render } from "./CreateOpportunity.vue?vue&type=template&id=117cf4a0&scoped=true"
import script from "./CreateOpportunity.vue?vue&type=script&lang=js"
export * from "./CreateOpportunity.vue?vue&type=script&lang=js"

import "./CreateOpportunity.vue?vue&type=style&index=0&id=117cf4a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-117cf4a0"]])

export default __exports__